<template>
	<ValueListView @onListChange="onChangeValue" :locatorId="locatorId"/>
	<div class="child-content">
		<SearchValueView v-if="valueListValue" :locatorId="locatorId" :valueListValue="valueListValue" />
	</div>
</template>

<script lang="ts">
import {defineComponent, ref} from "vue";
import ValueListView from "@/apps/administration/views/squeeze/locators/tabs/ValueListView.vue";
import {useI18n} from "vue-i18n";
import {useToast} from "primevue/usetoast";
import {LocatorValueList} from "@dex/squeeze-client-ts";
import SearchValueView from "@/apps/administration/views/squeeze/locators/tabs/SearchValueView.vue";

export default defineComponent({
	name: "KeyWordsToValueView",
	components: {
		ValueListView, SearchValueView,
	},
	props: {
		locatorId: {
			type: Number,
			default: 0,
			required: true,
		},
	},
	emits: ['onLocatorChange'],
	setup() {
		const {t} = useI18n();
		const toast = useToast();
		const valueListValue = ref<string|undefined>(undefined);

		/** Triggered when a value list value is chosen */
		const onChangeValue = (value: LocatorValueList) => {
			valueListValue.value = value.value;
		}

		return {t, toast, valueListValue,
			onChangeValue};
	},
});
</script>

<style scoped>
.p-tabview-panel {
	overflow: hidden;
}

.child-content {
	height: 100%;
	max-height: calc(100% - 5rem); /* 5rem = height of the ValueListView above */
}
</style>
